var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 18",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 18C4.5 18 .3 9.8.1 9.4c-.1-.2-.1-.6 0-.8C.3 8.2 4.5 0 12 0s11.7 8.2 11.9 8.6c.1.3.1.6 0 .9-.2.3-4.4 8.5-11.9 8.5zM2.1 9c.9 1.6 4.5 7 9.9 7s8.9-5.4 9.9-7C21 7.4 17.4 2 12 2S3.1 7.4 2.1 9z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z",
    fill: "currentColor"
  })));
}

export default SvgEye;